import {DataSource, IDataSourceRequestInit} from '../../../shared/DataSource';
import {IMultiNode} from '../DataMultiBtnSelect';

import { IFilters, userData } from "../../../util/userData";

export class FiltersDataSource extends DataSource<IMultiNode, any> {
  constructor(protected objectKey: string) {
    super(
      process.env.DATA_SOURCES_URL,
      {
        method: "POST",
        recordsPath: "data.data",
        visualizationPath: "visualization",
        credentials: "same-origin",
        updateRequestOnSync: (requestInit) => this.insertFilters(requestInit),
      }
    );
  }

  insertFilters(
    requestInit: IDataSourceRequestInit
  ): Promise<IDataSourceRequestInit> {
    return userData.getToken().then((tokenRes) => {
      const appFilters = userData.getFilters();
      if (!appFilters.securityType) {
        appFilters.securityType =
          window.location.href.indexOf("coachingoverview") !== -1
            ? "COACHINGFORM"
            : "DASHBOARD";
      }
      if (!appFilters.survey) {
        appFilters.survey = "ALL";
      }
      const version = tokenRes.version;
      const projectFilter: IFilters = {
        id: "project",
        value: tokenRes.project,
      };
      const userFilter: IFilters = { id: "user_id", value: tokenRes.userId };
      const appFiltersMapped = Object.keys(appFilters).map((id) => ({
        id,
        value: appFilters[id],
      }));
      const objectKey = `100001/Application/${tokenRes.version}${this.objectKey}`;
      const sessionKey = tokenRes.session;
      const filters: IFilters[] = [
        projectFilter,
        userFilter,
        ...appFiltersMapped,
      ];
      const bodyObj = { objectKey, version, sessionKey, filters };

      requestInit.body = JSON.stringify(bodyObj);

      return requestInit;
    });
  }
}

// tslint:disable-next-line:max-classes-per-file
class PeriodsDataSourceClass extends DataSource<IMultiNode, any> {
  constructor() {
    super("/scripts/periods/get_periods", {
      method: "POST",
      recordsPath: "data.data",
      visualizationPath: "visualization",
      credentials: "same-origin",
      updateRequestOnSync: (requestInit) => this.insertFilters(requestInit),
    });
  }

  insertFilters(
    requestInit: IDataSourceRequestInit
  ): Promise<IDataSourceRequestInit> {
    return userData.getToken().then((tokenRes) => {
      const appFilters = userData.getFilters();
      if (!appFilters.securityType) {
        appFilters.securityType =
          window.location.href.indexOf("coachingoverview") !== -1
            ? "COACHINGFORMS"
            : "DASHBOARD";
      }
      const version = tokenRes.version;
      const projectFilter: IFilters = {
        id: "project",
        value: tokenRes.project,
      };
      const userFilter: IFilters = { id: "user_id", value: tokenRes.userId };
      const appFiltersMapped = Object.keys(appFilters).map((id) => ({
        id,
        value: appFilters[id],
      }));
      const sessionKey = tokenRes.session;
      const filters: IFilters[] = [
        projectFilter,
        userFilter,
        ...appFiltersMapped,
      ];
      const bodyObj = { version, sessionKey, filters };

      requestInit.body = JSON.stringify(bodyObj);

      return requestInit;
    });
  }
}

// tslint:disable-next-line:max-classes-per-file
class SourcesDataSourceClass extends DataSource<IMultiNode, any> {
  constructor() {
    super("/scripts/social_media/get_sources", {
      method: "POST",
      recordsPath: "data.data",
      visualizationPath: "visualization",
      credentials: "same-origin",
      updateRequestOnSync: (requestInit) => this.insertFilters(requestInit),
    });
  }

  insertFilters(
    requestInit: IDataSourceRequestInit
  ): Promise<IDataSourceRequestInit> {
    return userData.getToken().then((tokenRes) => {
      const appFilters = userData.getFilters();
      if (!appFilters.securityType) {
        appFilters.securityType =
          window.location.href.indexOf("coachingoverview") !== -1
            ? "COACHINGFORMS"
            : "DASHBOARD";
      }
      const version = tokenRes.version;
      const projectFilter: IFilters = {
        id: "project",
        value: tokenRes.project,
      };
      const userFilter: IFilters = { id: "user_id", value: tokenRes.userId };
      const appFiltersMapped = Object.keys(appFilters).map((id) => ({
        id,
        value: appFilters[id],
      }));
      const sessionKey = tokenRes.session;
      const filters: IFilters[] = [
        projectFilter,
        userFilter,
        ...appFiltersMapped,
      ];
      const bodyObj = { version, sessionKey, filters };

      requestInit.body = JSON.stringify(bodyObj);

      return requestInit;
    });
  }
}

class CustomRangePeriodsDataSourceClass extends DataSource<IMultiNode, any> {
  constructor() {
    super("/scripts/periods/get_periods", {
      method: "POST",
      recordsPath: "data.data",
      visualizationPath: "visualization",
      credentials: "same-origin",
      updateRequestOnSync: (requestInit) => this.insertFilters(requestInit),
    });
  }

  protected setDataFetch(): Promise<void> {
    return super.setDataFetch().then(() => {
      this.records.push(
        { value: "custom_range", label: "Custom Range", nodes: [
            { value: "custom_range_selector", label: "Custom Range", nodes: [], selectable: false }
          ], selectable: false },
      );
    })
  }

  insertFilters(
    requestInit: IDataSourceRequestInit
  ): Promise<IDataSourceRequestInit> {
    return userData.getToken().then((tokenRes) => {
      const appFilters = userData.getFilters();
      if (!appFilters.securityType) {
        appFilters.securityType =
          window.location.href.indexOf("coachingoverview") !== -1
            ? "COACHINGFORMS"
            : "DASHBOARD";
      }
      const version = tokenRes.version;
      const projectFilter: IFilters = {
        id: "project",
        value: tokenRes.project,
      };
      const userFilter: IFilters = { id: "user_id", value: tokenRes.userId };
      const appFiltersMapped = Object.keys(appFilters).map((id) => ({
        id,
        value: appFilters[id],
      }));
      const sessionKey = tokenRes.session;
      const filters: IFilters[] = [
        projectFilter,
        userFilter,
        ...appFiltersMapped,
      ];
      const bodyObj = { version, sessionKey, filters };

      requestInit.body = JSON.stringify(bodyObj);

      return requestInit;
    });
  }
}


// tslint:disable-next-line:max-classes-per-file
class MonthlyPeriodsDataSourceClass extends DataSource<IMultiNode, any> {
  constructor() {
    super("scripts/periods/get_monthly_periods", {
      method: "POST",
      recordsPath: "data.data",
      visualizationPath: "visualization",
      credentials: "same-origin",
      updateRequestOnSync: (requestInit) => this.insertFilters(requestInit),
    });
  }

  insertFilters(
    requestInit: IDataSourceRequestInit
  ): Promise<IDataSourceRequestInit> {
    return userData.getToken().then((tokenRes) => {
      const appFilters = userData.getFilters();
      if (!appFilters.securityType) {
        appFilters.securityType =
          window.location.href.indexOf("coachingoverview") !== -1
            ? "COACHINGFORMS"
            : "DASHBOARD";
      }
      const version = tokenRes.version;
      const projectFilter: IFilters = {
        id: "project",
        value: tokenRes.project,
      };
      const userFilter: IFilters = { id: "user_id", value: tokenRes.userId };
      const appFiltersMapped = Object.keys(appFilters).map((id) => ({
        id,
        value: appFilters[id],
      }));
      const sessionKey = tokenRes.session;
      const filters: IFilters[] = [
        projectFilter,
        userFilter,
        ...appFiltersMapped,
      ];
      const bodyObj = { version, sessionKey, filters };

      requestInit.body = JSON.stringify(bodyObj);

      return requestInit;
    });
  }
}

class YearlyPeriodsDataSourceClass extends DataSource<IMultiNode, any> {
  constructor() {
    super("scripts/periods/get_yearly_periods", {
      method: "POST",
      recordsPath: "data.data",
      visualizationPath: "visualization",
      credentials: "same-origin",
      updateRequestOnSync: (requestInit) => this.insertFilters(requestInit),
    });
  }

  insertFilters(
    requestInit: IDataSourceRequestInit
  ): Promise<IDataSourceRequestInit> {
    return userData.getToken().then((tokenRes) => {
      const appFilters = userData.getFilters();
      if (!appFilters.securityType) {
        appFilters.securityType =
          window.location.href.indexOf("coachingoverview") !== -1
            ? "COACHINGFORMS"
            : "DASHBOARD";
      }
      const version = tokenRes.version;
      const projectFilter: IFilters = {
        id: "project",
        value: tokenRes.project,
      };
      const userFilter: IFilters = { id: "user_id", value: tokenRes.userId };
      const appFiltersMapped = Object.keys(appFilters).map((id) => ({
        id,
        value: appFilters[id],
      }));
      const sessionKey = tokenRes.session;
      const filters: IFilters[] = [
        projectFilter,
        userFilter,
        ...appFiltersMapped,
      ];
      const bodyObj = { version, sessionKey, filters };

      requestInit.body = JSON.stringify(bodyObj);

      return requestInit;
    });
  }
}

// tslint:disable-next-line:max-classes-per-file
class HierarchyDataSourceClass extends FiltersDataSource {
  private showAllCoachingFormOption = true;

  constructor() {
    super("/app/reports/filters/hierarchy/");
  }

  setShowAllCoachingFormOption(bool: boolean) {
    this.showAllCoachingFormOption = bool;
  }

  protected setDataFetch() {
    return super.setDataFetch().then(() => {
      const firstRecordNodes = this.records[0] && this.records[0].nodes;

      if (this.showAllCoachingFormOption && firstRecordNodes) {
        const hasAllOption = firstRecordNodes.find((s) => s.value === "ALL");

        if (!hasAllOption) {
          if (window.location.href.indexOf("coachingoverview") !== -1)
            firstRecordNodes.push({
              value: "ALL",
              label: "All Coaching Forms",
              nodes: [],
            });
          else
            firstRecordNodes.push({
              value: "ALL",
              label: "All Comments",
              nodes: [],
            });
        }
      }
    });
  }
}

class HierarchyMyAlertsDataSourceClass extends FiltersDataSource {
  private showAllCoachingFormOption = true;

  constructor() {
    super("/app/reports/filters/hierarchy/");
  }

  setShowAllCoachingFormOption(bool: boolean) {
    this.showAllCoachingFormOption = bool;
  }

  protected setDataFetch() {
    return super.setDataFetch().then(() => {
      const originalRecords = this.records ? this.records : [];
      let firstRecordNodes = (originalRecords.length > 0 ? (originalRecords[0] && originalRecords[0].nodes) : []);
      let newRecords = [];

      if (originalRecords.length > 0) {
        newRecords.push({
          value: this.records[0].value,
          label: this.records[0].label,
          nodes: [],
          distance: 0,
        });
      }
      firstRecordNodes.forEach((r) => {
        newRecords.push(r);
      });

      this.records = [];
      this.records.push(
        { value: "My_alerts", label: "My alerts", nodes: [], selectable: true },
      );
      if (originalRecords.length > 0) {
        this.records.push(
          {
            value: 'My_access',
            label: 'My access',
            nodes: originalRecords,
            selectable: false,
          }
        );
      }
    });
  }
}

export class TeamDataSource extends DataSource<IMultiNode, any> {
  constructor(protected objectKey?: string) {
    super(
      `/scripts/avids/avids_get_nested_dropdown?user_id=0&type=COACHINGFORM&project=${userData.getCurrentProject()}`,
      {
        method: "GET",
        recordsPath: "data.data",
        visualizationPath: "visualization",
        credentials: "same-origin",
        updateRequestOnSync: (requestInit) => this.insertFilters(requestInit),
      }
    );
  }

  insertFilters(
    requestInit: IDataSourceRequestInit
  ): Promise<IDataSourceRequestInit> {
    return userData.getToken().then(() => {
      const appFilters = userData.getFilters();
      if (!appFilters.securityType) {
        appFilters.securityType =
          window.location.href.indexOf("coachingoverview") !== -1
            ? "COACHINGFORMS"
            : "DASHBOARD";
      }

      return requestInit;
    });
  }
}

class TeamSelectorDropdownDataSourceClass extends TeamDataSource {
  private showAllCoachingFormOption = true;

  constructor() {
    super("/app/reports/filters/hierarchy/");
  }

  setShowAllCoachingFormOption(bool: boolean) {
    this.showAllCoachingFormOption = bool;
  }

  protected setDataFetch() {
    return super.setDataFetch();
  }
}

class TeamSelectorDataSourceClass extends FiltersDataSource {
  private showAllCoachingFormOption = true;

  constructor() {
    super("/app/reports/filters/hierarchy/");
  }

  setShowAllCoachingFormOption(bool: boolean) {
    this.showAllCoachingFormOption = bool;
  }

  protected setDataFetch() {
    return super.setDataFetch();
  }
}

class CommentTypesDataSourceClass extends FiltersDataSource {
  constructor() {
    super("/app/reports/filters/questionTypes/");
  }

  protected setDataFetch() {
    return super.setDataFetch().then(() => {
      let neutral = [];
      let sugg = [];
      let comp = [];
      let all = [];
      let records = [];

      if (this.records) {
        this.records.map((item) => {
          if (item["parentid"] == "Suggestion") {
            sugg.push(item);
          }
          if (item["parentid"] == "Neutral") {
            neutral.push(item);
          }
          if (item["parentid"] == "Compliment") {
            comp.push(item);
          }
          if (item["parentid"] == "All Comments") {
            all.push(item);
          }
        });
      }

      records.push({
        distance: 1,
        label: "All Comments",
        selectable: false,
        value: "allcomments",
        nodes: all,
      });
      records.push({
        distance: 1,
        label: "Compliment",
        selectable: false,
        value: "compliment",
        nodes: comp,
      });
      records.push({
        distance: 1,
        label: "Suggestion",
        selectable: false,
        value: "suggestion",
        nodes: sugg,
      });
      records.push({
        distance: 1,
        label: "Neutral",
        selectable: false,
        value: "compliment",
        nodes: neutral,
      });

      this.records = records;
    });
  }
}

const HierarchyDataSource = new HierarchyDataSourceClass();
const CustomRangePeriodsDataSource = new CustomRangePeriodsDataSourceClass();
const HierarchyMyAlertsDataSource = new HierarchyMyAlertsDataSourceClass();
const TeamSelectorDataSource = new TeamSelectorDataSourceClass();
const TeamDropdown = new TeamSelectorDropdownDataSourceClass();
const PeriodsDataSource = new PeriodsDataSourceClass();
const MonthlyPeriodsDataSource = new MonthlyPeriodsDataSourceClass();
const YearlyPeriodsDataSource = new YearlyPeriodsDataSourceClass();
const SegmentsDataSource = new FiltersDataSource(
  "/app/reports/filters/segmentChildren/"
);
const SegmentParentsDataSource = new FiltersDataSource(
  "/app/reports/filters/segmentParents/"
);
const SurveysDataSource = new FiltersDataSource(
  "/app/reports/filters/surveys/"
);
const QuestionsDataSource = new FiltersDataSource(
  "/app/reports/filters/questions/"
);
const CommentTypesDataSource = new CommentTypesDataSourceClass();
const ProjectsDataSource = new FiltersDataSource(
  "/app/reports/filters/projects/"
);
const SourcesDataSource = new SourcesDataSourceClass();
HierarchyDataSource.addDataSourceListener(
  SurveysDataSource,
  SegmentsDataSource,
  SegmentParentsDataSource
);

SurveysDataSource.addDataSourceListener(
  HierarchyDataSource,
  QuestionsDataSource,
  SegmentsDataSource,
  SegmentParentsDataSource
);

export {
  CustomRangePeriodsDataSource,
  HierarchyDataSource,
  HierarchyMyAlertsDataSource,
  TeamSelectorDataSource,
  TeamDropdown,
  PeriodsDataSource,
  SegmentsDataSource,
  SegmentParentsDataSource,
  SurveysDataSource,
  QuestionsDataSource,
  CommentTypesDataSource,
  ProjectsDataSource,
  MonthlyPeriodsDataSource,
  YearlyPeriodsDataSource,
  SourcesDataSource,
};
